var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm._v(" " + _vm._s(_setup.formatDate(_vm.item[_vm.header.value])) + " "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }